export default __webpack_public_path__ + "94e24f8a187554cc2d8b18c4b8d91106.png";